export default __webpack_public_path__ + "static/abhinav-56ce989af2655747665bc2d7046d76ba.png";